export function enumToPgEnum(myEnum) {
    return Object.values(myEnum).map((value) => `${value}`);
}
